const SearchParams = Object.freeze({
  CHAT_ID: 'chat-id',
  EMAIL: 'email',
  CLIENT_SECRET: 'client-secret',
  REDIRECT_URL: 'redirect-url',
  FORCE_RESPONSE: 'force-response',
  TOKEN: 'token',
  RETURN_URL: 'returnUrl',
  CURRENT_PLAN: 'current-plan',
} as const);

export type SearchParams = (typeof SearchParams)[keyof typeof SearchParams];
export default SearchParams;
